import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../../components/EmptyState/EmptyState';
import { LANG_TEXT } from '../../../../constants/language';
import usePermission from '../../../../hooks/usePermission';
import { TabPanelProps } from '../../../../interfaces/index.types';
import { IFoodDetails } from '../../menu.types';
import Card from '../Card/Card';
import Loader from '../Loader/Loader';

export function ListMenu(props: TabPanelProps & { result: IFoodDetails[]; value: number; loading: boolean; toggleDrawer: (open: boolean, data: any) => void; bulkPreOrderEnabled?: boolean }) {
  const { t } = useTranslation();
  const { isAdminActionBlocked } = usePermission();

  return props.loading ? (
    <Loader />
  ) : props.result?.length > 0 ? (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        {props.result.map((item: IFoodDetails, index: number) => (
          <Grid sx={{ width: '100%' }} item sm={12} md={6} lg={isAdminActionBlocked ? 6 : 4} key={index}>
            <Card food={item} toggleDrawer={props.toggleDrawer} bulkPreOrderEnabled={props.bulkPreOrderEnabled} />
          </Grid>
        ))}
      </Grid>
    </Box>
  ) : (
    <EmptyState title={t(LANG_TEXT.NO_MENUS)} />
  );
}
